import { di } from 'react-magnetic-di';
import { ISSUE_VIEW_URL_REGEX } from './constants.tsx';

export const isIssueViewPage = () => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window.location.pathname.match(ISSUE_VIEW_URL_REGEX);
};
